const baseUrl = 'https://api.flipdish.co';

export const getStoreLeadTimes = async (
  storeId: number,
): Promise<StoreLeadTimesResponse> => {
  try {
    const response = await fetch(`${baseUrl}/restaurant/leadtimes/${storeId}`);
    return await response.json();
  } catch (error: any) {
    return error;
  }
};

export type StoreLeadTimesResponse = {
  Success: boolean;
  Data: {
    LeadTimeMinutes: {
      Collection: number;
      Delivery: number;
    };
  };
};
